import axios from "axios";
import { backendDomain } from "../../paths";

const instance = axios.create({
  baseURL: backendDomain + "/api/v1/curator/",
  headers: {
    "Content-Type": "application/json;charset=utf-8",
    "content-type": "application/json;charset=utf-8",
    Authorization: localStorage.getItem("curatorToken"),
  },
});

export default instance;
